import { isSSG } from 'modules/common/utils/isSSG';
import { useCurrentTopBanners } from 'modules/strapi/hooks/useCurrentTopBanners';

import { TopBanners } from './TopBanners';

export const TopBannersContainer = () => {
  const { loaded, topBanners } = useCurrentTopBanners();

  if (!loaded || !topBanners || isSSG()) {
    return null;
  }

  return <TopBanners banners={topBanners} />;
};
